module.exports = __webpack_public_path__ + "img/footer-1-lg.57f79a13.svg";